import { createPersistedStoreWithShopId } from '~/utils/createPersistedStore';

export interface IPageAnalyticDetailsStoreState {
  pageTitle?: string;
  setPageTitle: (pageTitle: string) => void;
}
export const usePageAnalyticDetailsStore =
  createPersistedStoreWithShopId<IPageAnalyticDetailsStoreState>(
    'page-analytic-details',
    (set) => ({
      pageTitle: undefined,
      setPageTitle: (pageTitle) => set({ pageTitle }),
    }),
  );
